var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolbarYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    fill: "#ff9090",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M 22 40.332031 C 32.125 40.332031 40.332031 32.125 40.332031 22 C 40.332031 11.875 32.125 3.667969 22 3.667969 C 11.875 3.667969 3.667969 11.875 3.667969 22 C 3.667969 32.125 11.875 40.332031 22 40.332031 Z M 19.605469 29.050781 L 28.257812 23.941406 C 29.691406 23.09375 29.691406 20.90625 28.257812 20.058594 L 19.605469 14.949219 C 18.210938 14.125 16.5 15.199219 16.5 16.890625 L 16.5 27.109375 C 16.5 28.800781 18.210938 29.875 19.605469 29.050781 Z M 19.605469 29.050781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolbarYoutube);
export default __webpack_public_path__ + "static/media/Icon_Toolbar_Youtube.8e621cd52093a698722378a6a64076f2.svg";
export { ForwardRef as ReactComponent };